class ProductListTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger || !this.contains(trigger)) return;

    const targetId = trigger.dataset.tabTrigger;
    if (trigger.classList.contains('product-list-tabs__pill--active')) return;

    this.querySelectorAll('[data-tab-trigger]').forEach((pill) => {
      const isActive = pill === trigger;
      pill.classList.toggle('product-list-tabs__pill--active', isActive);
      pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== targetId;
    });
  };
}

if (!customElements.get('product-list-tabs')) {
  customElements.define('product-list-tabs', ProductListTabs);
}
